/* istanbul ignore file */

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/es';

import { ko, enUS } from 'date-fns/locale';

import koClassroom from './ko/classroom.translations.json';
import enClassroom from './en/classroom.translations.json';
import jaClassroom from './ja/classroom.translations.json';
import esClassroom from './es/classroom.translations.json';
import viClassroom from './vi/classroom.translations.json';
import zhTWClassroom from './zh-TW/classroom.translations.json';
import zhHKClassroom from './zh-HK/classroom.translations.json';

import koNotification from './ko/notification.translations.json';
import enNotification from './en/notification.translations.json';
import jaNotification from './ja/notification.translations.json';
import esNotification from './es/notification.translations.json';
import viNotification from './vi/notification.translations.json';
import zhTWNotification from './zh-TW/notification.translations.json';

import { env } from 'utils/env';

// FIXME 국가 코드도 대응이 가능하도록 처리 필요(ex. locale이 ko-KR, ko일 때 모두 ko로 인지할 수 있도록 대응)
export const datePickerLocales: Record<string, { key: string; locale: any }> = {
  ko: { key: 'ko', locale: ko },
  'en-US': { key: 'enUS', locale: enUS },
};

const translationsJson = {
  ko: {
    classroom: koClassroom,
    notification: koNotification,
  },
  en: {
    classroom: enClassroom,
    notification: enNotification,
  },
  es: {
    classroom: esClassroom,
    notification: esNotification,
  },
  ja: {
    classroom: jaClassroom,
    notification: jaNotification,
  },
  vi: {
    classroom: viClassroom,
    notification: viNotification,
  },
  'zh-TW': {
    classroom: zhTWClassroom,
    notification: zhTWNotification,
  },
  'zh-HK': {
    classroom: zhHKClassroom,
    notification: zhTWNotification,
  },
};

const KEY_I18NEXT_LNG = 'i18nextLng';
const isProd = env.STAGE !== 'dev' && env.STAGE !== 'stag';

i18next
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      resources: translationsJson,
      ns: ['classroom', 'notification'],
      defaultNS: 'classroom',
      fallbackLng: 'en',
      debug: false,

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
        format: function (value, format, lng = 'en') {
          if (value instanceof Date) {
            let lang = lng;

            if (lng === 'ko-KR') {
              lang = 'ko';
            }

            return dayjs(value).locale(lang).format(format);
          }

          return value;
        },
      },

      detection: {
        order: ['querystring', 'sessionStorage', 'navigator'],
        caches: ['sessionStorage'],
        excludeCacheFor: ['cimode'],

        // keys or params to lookup language from
        lookupQuerystring: 'lng',
        lookupSessionStorage: KEY_I18NEXT_LNG,
      },
    },
    (err) => {
      if (err) {
        return console.log('something went wrong loading', err);
      }

      if (isProd && i18next.language === 'cimode') {
        i18next.changeLanguage('en').then(() => {
          document.documentElement.setAttribute('lang', i18next.language);
        });
        return;
      }

      document.documentElement.setAttribute('lang', i18next.language);
    }
  );

export default i18next;
